var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayMastercard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 43.3714 26.4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.0219 13.2002C43.0219 20.4928 37.1149 26.4002 29.8299 26.4002C22.5448 26.4002 16.6378 20.4928 16.6378 13.2002C16.6378 5.90763 22.5357 0.000195313 29.8207 0.000195313C37.1057 0.000195313 43.0219 5.90763 43.0219 13.2002Z",
    fill: "var(--fill-0, #F79F1A)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.7338 13.2002C26.7338 20.4928 20.8267 26.4002 13.5417 26.4002C6.25667 26.4002 0.349648 20.4928 0.349648 13.2002C0.349648 5.90763 6.25667 0.000195313 13.5417 0.000195313C20.8267 0.000195313 26.7338 5.90763 26.7338 13.2002Z",
    fill: "var(--fill-0, #EA001B)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.6806 2.80713C18.6031 5.21964 16.6279 8.98058 16.6279 13.2002C16.6279 17.4198 18.6031 21.1807 21.6806 23.5932C24.7581 21.1807 26.7333 17.4198 26.7333 13.2002C26.7333 8.98058 24.7581 5.22881 21.6806 2.80713Z",
    fill: "var(--fill-0, #FF5F01)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.3714,
    height: 26.4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayMastercard);
export default __webpack_public_path__ + "static/media/pay-mastercard.5b2572807494093b78aeb870e36457f5.svg";
export { ForwardRef as ReactComponent };